import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_BASE_URL;
let username = process.env.REACT_APP_OAUTH2_CLIENT
let password = process.env.REACT_APP_OAUTH2_SECRET

export const config = () => {
  return {
    headers: {
      Authorization: 'Basic dGVzdGNsaWVudDp0ZXN0c2VjcmV0',
      "Content-Type": "application/x-www-form-urlencoded",
    },
  };
};

export async function POST(values, module, setError, reset) {
  const URL = BASE_URL + module;

  // para enviar la data en formato x-www-form-urlencoded
  const params = new URLSearchParams();
  values.forEach(function (valor) {
    localStorage.getItem(valor) === null
      ? params.append(valor, "")
      : params.append(valor, localStorage.getItem(valor));
  });

  try {
    const { data } = await axios.post(URL, params, config());
    reset?.();
    return data;
  } catch (error) {
    console.log(error.response?.data.messages);
    return error.response?.data.messages;
  }
}

export async function GET(module, id = null) {
  let URL;

  if (id) {
    URL = BASE_URL + module + "/" + id;
  } else {
    URL = BASE_URL + module;
  }

  try {
    const { data } = await axios.get(URL, config());
    return data;
  } catch (error) {
    console.log(error);
    return error.response.data;
  }
}

export async function DELETE(module, id) {
  if (!id) {
    throw new Error("Necesitas enviar un id");
  }

  const URL = BASE_URL + module + "/" + id;

  try {
    const data = await axios.delete(URL, config());
    return data;
  } catch (error) {
    console.log(error);
  }
}

export async function PUT(values, module, id, setError, reset) {
  const URL = BASE_URL + module + "/" + id;

  const params = new URLSearchParams();
  values.forEach(function (valor) {
    localStorage.getItem(valor) === null
      ? params.append(valor, "")
      : params.append(valor, localStorage.getItem(valor));
  });

  try {
    const { data } = await axios.put(URL, params, config());
    reset?.();
    return data;
  } catch (error) {
    console.log(error.response.data.messages);
    return error.response?.data.messages;
  }
}

export async function PUT_ORDER(array, id) {
  const URL = BASE_URL + "doc_mdinfo/" + id;

  let arr = array.map((item) => item.dmt_int_id);
  arr = arr.join();

  const params = new URLSearchParams();
  params.append("arr", arr);

  try {
    const { data } = await axios.put(URL, params, config());
    return data;
  } catch (error) {
    console.log(error.response.data.messages);
  }
}

export async function POST_IMPORT(sendData, module) {
  const URL = BASE_URL + module;

  try {
    const { data } = await axios.post(URL, sendData, config());
    return data;
  } catch (error) {
    console.log(error.response?.data.messages);
    return error.response?.data.messages;
  }
}

export async function PUT_IMPORT(values, module, id, setError, reset) {
  const URL = BASE_URL + module + "/" + id;


  try {
    const { data } = await axios.put(URL, values, config());
    reset?.();
    return data;
  } catch (error) {
    console.log(error.response.data.messages);
    return error.response?.data.messages;
  }
}

export async function POST_LANGUAGE(module, reset) {
  const URL = BASE_URL + module;

  // para enviar la data en formato x-www-form-urlencoded
  const formdata = new URLSearchParams();
  formdata.append('lang', sessionStorage.getItem('languageId'));


  try {
    const { data } = await axios.post(URL, formdata, config());
    reset?.();
    return data;
  } catch (error) {
    console.log(error.response?.data.messages);
    return error.response?.data.messages;
  }
}

export async function GET_LANGUAGE(module, reset) {
  
  const lang  = sessionStorage.getItem('languageId')
  const URL = BASE_URL + module+ "/" + lang.toLowerCase();


  try {
    const { data } = await axios.get(URL,  config());
    reset?.();
    return data;
  } catch (error) {
    console.log(error.response?.data.messages);
    return error.response?.data.messages;
  }
}
